import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2630_9269)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.38149 0.940866C6.57043 0.835242 6.78329 0.779785 6.99973 0.779785C7.2162 0.779785 7.42905 0.835242 7.618 0.940866C7.80691 1.04649 7.96564 1.19876 8.07904 1.38315L8.08408 1.39138L13.8264 11.3354C13.8269 11.3362 13.8274 11.3371 13.8279 11.338C13.9386 11.5276 13.9975 11.7429 13.9988 11.9624C14.0001 12.183 13.9432 12.4 13.8338 12.5915C13.7243 12.783 13.5663 12.9422 13.3756 13.053C13.185 13.1639 12.9684 13.2224 12.7478 13.2228L12.7467 12.5228V13.2228H1.25274H1.25163C1.03108 13.2224 0.814518 13.1639 0.62384 13.053C0.433166 12.9422 0.275129 12.783 0.165702 12.5915C0.0562742 12.4 -0.000666801 12.183 0.000632086 11.9624C0.00192496 11.7429 0.0608799 11.5275 0.171566 11.338L5.91537 1.39138L5.92044 1.38315C6.03381 1.19876 6.19254 1.04649 6.38149 0.940866ZM12.4912 11.8228L6.99973 2.31318L1.50827 11.8228H12.4912Z"
				}),
				/* @__PURE__ */ _jsx("path", { d: "M7.69987 4.71094L7.40587 8.78494H6.59387L6.29987 4.71094H7.69987Z" }),
				/* @__PURE__ */ _jsx("path", { d: "M6.99975 9.94001C6.92379 9.93881 6.84839 9.95345 6.77844 9.98305C6.70847 10.0126 6.64544 10.0565 6.59339 10.1119C6.54134 10.1672 6.50141 10.2328 6.47615 10.3045C6.4509 10.3761 6.4409 10.4522 6.44675 10.528C6.44675 10.6747 6.50499 10.8153 6.60871 10.919C6.71242 11.0227 6.85309 11.081 6.99975 11.081C7.14642 11.081 7.28706 11.0227 7.39077 10.919C7.49449 10.8153 7.55275 10.6747 7.55275 10.528C7.55861 10.4522 7.54858 10.3761 7.52333 10.3045C7.49807 10.2328 7.45814 10.1672 7.40609 10.1119C7.35404 10.0565 7.29104 10.0126 7.22107 9.98305C7.15109 9.95345 7.07572 9.93881 6.99975 9.94001Z" })
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2630_9269",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 14,
				height: 14
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgWarning);
export default ForwardRef;
